const enumValue = (name) => Object.freeze({ toString: () => name });
/**
 * @description Views types const. FFA is not currently implemented
 */
export const DiagramViews = Object.freeze({
    GRID: enumValue("Views.GRID"),
    FFA: enumValue("Views.FFA")
});
